const normalizedApiOrigin = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

export const API_ORIGIN = normalizedApiOrigin;
export const BLOG_API_BASE = `${normalizedApiOrigin}/api/blog`;
